import React, { useState } from 'react';
import AdminNews from './AdminNews';
import AdminStock from './AdminStock';
import './AdminPanel.css';
import './uploads/Admin.css';
import AdminPrivateSectorTariffs from './AdminPrivateSectorTariffs';

function AdminPanel() {
  const [activePage, setActivePage] = useState('news');

  const renderPage = () => {
    switch (activePage) {
      case 'news':
        return <AdminNews />;
      case 'tariffs':
        return <AdminPrivateSectorTariffs />;
      case 'stock':
        return <AdminStock />;
      default:
        return <div>Выберите раздел</div>;
    }
  };

  return (
    <div className="admin-container">
      <nav className="admin-menu">
        <h3>Меню админа</h3>
        <ul>
          <li>
            <button
              className={activePage === 'news' ? 'active' : ''}
              onClick={() => setActivePage('news')}
            >
              Новости
            </button>
          </li>
          <li>
            <button
                className={activePage === 'tariffs' ? 'active' : ''}
                onClick={() => setActivePage('tariffs')}
            >
              Тарифы частного сектора
            </button>
          </li>
          <li>
            <button
                className={activePage === 'stock' ? 'active' : ''}
                onClick={() => setActivePage('stock')}
            >
              Акции
            </button>
          </li>
        </ul>
      </nav>
      <main className="admin-main">
        {renderPage()}
      </main>
    </div>
  );
}

export default AdminPanel;